import { useQuery } from "@tanstack/react-query";
import { DevourPlayApi, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

export type TimeFilter = "day" | "week" | "month" | "year" | "all" | "custom";

export interface GamingXPTransactionHistoryItem {
    id: string;
    amount: number;
    type: "DEBIT" | "CREDIT";
    subject: string;
    description: string;
    createdAt: string;
}

export interface GamingXPTransactionHistoryResponse {
    transactions: GamingXPTransactionHistoryItem[];
    pagination: {
        total: number;
        limit: number;
        offset: number;
        hasMore: boolean;
    };
    timeFilter: string;
    startDate: string;
    endDate: string;
}

interface UseGetTransactionHistoryGamingXPParams {
    timeFilter?: TimeFilter;
    enabled?: boolean;
}

export const useGetTransactionHistoryGamingXP = (
    fullToken: Token | undefined,
    params: UseGetTransactionHistoryGamingXPParams = {},
) => {
    const { timeFilter = "all", enabled = true } = params;

    return useQuery({
        queryKey: ["transaction-history-gaming-xp-v1", fullToken?.token || "anonymous", timeFilter],
        queryFn: async () => {
            if (!fullToken?.token) {
                throw new Error("No authentication token");
            }
            return new DevourPlayApi(getConfig(fullToken)).getDevourplayTransactionHistoryGamingXp({
                timeFilter: timeFilter as any,
            });
        },
        enabled: enabled && !!fullToken?.token,
        staleTime: 1000 * 60 * 2, // Cache for 2 minutes per timeFilter
        gcTime: 1000 * 60 * 10, // Keep in memory for 10 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
};